import classNames from "classnames";
import styles from "./FormDescription.module.scss";

export const FormDescription = ({ children, className }) => (
  <p className={classNames(styles.root, className)}>{children}</p>
);
